import { useState } from 'react';
import { SkitterBookPrintMargin } from '../Models/SkitterBookPrintMargin';
import { ReactComponent as ImagePrintAlign } from '../../public/images/svg/ImagePrintAlign.svg';
import { SkitterBookLivePrintSideMargin } from './SkitterBookLivePrintSideMargin';
import { BaseButton } from '../Controls/Button/BaseButton';
import ExpanderPanel from '../Controls/ExpanderPanel';
import './css/SkitterBookLivePrintPageMargin.css';

export interface SkitterBookPrintPageMarginProps {
    frontPrintMargin?: SkitterBookPrintMargin;
    backPrintMargin?: SkitterBookPrintMargin;
    profileLastChangedOn: number | null;
    onFrontChange?: (value: SkitterBookPrintMargin) => void;
    onBackChange?: (value: SkitterBookPrintMargin) => void;
    onClear?: () => void;
}

export const SkitterBookLivePrintPageMargin: React.FC<SkitterBookPrintPageMarginProps> = ({ frontPrintMargin, backPrintMargin, profileLastChangedOn, onFrontChange, onBackChange, onClear }) => {

    return (
        <div className="skitterbook-live-print-page-margin-container">
            <ExpanderPanel iconComponent={<ImagePrintAlign width={32} height={32} viewBox="0 0 32 32" />}
                title="Correct printer misalignment">
                <div className="live-print-margin-inner">
                    <span className="lpmi-title">Tell Skitterbook how your printer is misbehaving and Skitterbook will compensate.</span>
                    <span className="lpmi-1">Skitterbook printing works best when the outside frame is centred on the page.</span>
                    <span className="lpmi-2">If your printer produces uneven margins, measure the distance between the paper edge and the printed frame on each side in millimetres, then enter the values below.</span>
                    <span className="lpmi-3">Do this for both the front and back pages in the print.</span>
                    <span className="lpmi-4">Skitterbook will automatically compensate for the printer's offset and centre the printed frame on the page.</span>

                    {profileLastChangedOn &&
                        <div className="lpmi-profile-container">
                            <span className="lpmi-profile">{`Loaded data from: ${new Date(profileLastChangedOn).toLocaleString()}`}</span>
                            <BaseButton ariaLabel="clear-profile" onClick={() => {
                                onClear?.();
                            }}>
                                <span className="lpmi-profile-clear">Clear Loaded Data</span>
                            </BaseButton>
                        </div>
                    }

                    <div className="skitterbook-live-print-page-inner-margin-container">
                        <div className="front-side-margin">
                            <span>Front</span>
                            <SkitterBookLivePrintSideMargin printMargin={frontPrintMargin} labelText="F" onChange={onFrontChange} />
                        </div>
                        <div className="back-side-margin">
                            <span>Back</span>
                            <SkitterBookLivePrintSideMargin printMargin={backPrintMargin} labelText="B" onChange={onBackChange} />
                        </div>
                    </div>
                </div>
            </ExpanderPanel>
        </div>
    );
};
